export const APP_STORE_URL = 'https://apps.apple.com/app/bokadirekt-skönhet-hälsa/id1449704181' as const;
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=se.bokadirekt.app.prod' as const;

// Every app promo shows this one rating, so they can't drift apart.
export const APP_RATING = { score: 4.9, count: 59000 } as const;
